import {AccordionSummary, Stack, useTheme} from '@mui/material';
import React from 'react';

import {Row} from 'presentation/components';
import {ContractTypeEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText, getUserInfoFromToken} from 'presentation/utils';
import {EnterpriseField} from '../EnterpriseField';
import {StyledAccordion, StyledAccordionDetails} from './styles';
import {UserInfoProps} from './types';

const {
	holderData,
	cardCode: userCardLabel,
	plan: planLabel,
	startOfTerm: startOfTermLabel,
} = translations['pt-br'].privateFlow.refund.holderDataPage.userInfo;

export const UserInfo = ({hideAccordion}: UserInfoProps) => {
	const theme = useTheme();
	const {beneficiary} = useAccountDataStore(store => store.accountData);
	const {nmPlano, dtAdesaoC, tipoContratacao, nmSocialUsuarioC, nmUsuarioC} = beneficiary;
	const {cdUsuario} = getUserInfoFromToken();

	const showCompanyField = tipoContratacao === ContractTypeEnum.EMPRESARIAL;

	return (
		<StyledAccordion>
			{!hideAccordion ? (
				<AccordionSummary
					expandIcon={
						<Icon
							name="expand-more-filled"
							color={theme.palette.primary.main}
							size={32}
						/>
					}
					aria-controls="panel1-content"
					id="panel1-header">
					<Row.Simple
						hiddenDivider
						variants={{title: 'subtitle2', value: 'subtitle1'}}
						title={holderData}
						value={formatText(nmSocialUsuarioC || nmUsuarioC)}
					/>
				</AccordionSummary>
			) : null}

			<StyledAccordionDetails>
				<Stack spacing={2}>
					{hideAccordion ? (
						<Row.Simple
							hiddenDivider
							variants={{title: 'subtitle2', value: 'subtitle1'}}
							title={holderData}
							value={formatText(nmSocialUsuarioC || nmUsuarioC)}
						/>
					) : null}
					<Row.Simple title={userCardLabel} value={cdUsuario} />

					{showCompanyField ? <EnterpriseField /> : null}
					<Row.Simple title={planLabel} value={nmPlano} />
					<Row.Simple title={startOfTermLabel} value={dtAdesaoC} hiddenDivider />
				</Stack>
			</StyledAccordionDetails>
		</StyledAccordion>
	);
};
